import Link from 'next/link'
import useTranslation from 'next-translate/useTranslation'

function FooterBottomSection() {
  const { t } = useTranslation('global')

  return (
    <div className="flex flex-col mt-12 ml-8 lg:ml-0">
      <p className="mb-2">{t('well_being_for_creators')}</p>
      <Link href="/contact">
        <p className="text-xs">{t('contact')}</p>
      </Link>
    </div>
  )
}

export default FooterBottomSection
